import Vue from "vue";
import VueRouter from "vue-router";
import icons from '../views/icons/icons.vue' /* To be removed */

import OidcCallback from '@/components/OidcCallback.vue'
import logoutSuccess from '@/components/LogoutSuccess.vue';
import store from '@/store'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'

import EmptyRouterView from '@/components/EmptyRouterView.vue'

import NotFoundView from '../views/404.vue'


Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Root",
        redirect: '/dashboard',
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("../views/Dashboard/dashboard.vue"),
        meta: {
            title: 'Dashboard'
        },
    },
    {
        path: "/icons",
        name: "icons",
        component: EmptyRouterView,
        meta: {
            title: 'icons'
        },
        children: [
            {
                path: '',
                name: 'icons',
                component: icons,
                meta: {
                    title: 'icons'
                }
            }
        ]
    },
    {
        path: '/add-tenant',
        name: 'AddTenant',
        component: () => import("../views/Onboarding/AddTenant"),
        meta: {
            title: 'Add Tenant'
        },
        children: [
            {
                path: '',
                component: () => import("../views/Onboarding/TenantDetailForm.vue"),
                name: 'TenantDetails'
            },
            {
                path: '/product-package',
                component: () => import("../views/Onboarding/ProductSelection"),
                name: 'AddProduct-Package'
            },
            {
                path: '/user-role',
                component: () => import("../views/Onboarding/AddUsers"),
                name: 'AddTenantUser'
            },
            {
                path: '/database',
                component: () => import("../views/Onboarding/DatabaseConfig"),
                name: 'DatabaseConfig'
            }
        ]
    },
    {
        path: "/product-config",
        name: "Product Configuration",
        component: EmptyRouterView,
        meta: {
            title: 'Product Configuration'
        },
        children: [
            {
                path: '',
                component: () => import("../views/productConfiguration/productConfiguration.vue"),
                name: 'Product'
            },
            {
                path: 'add',
                component: () => import("../views/productConfiguration/productAdd"),
                name: 'AddProduct'
            }
        ]
    },
    {
        path: "/client-management",
        name: "Client Management",
        component: EmptyRouterView,
        meta: {
            title: 'Client Management'
        },
        children: [
            {
                path: '',
                component: () => import("../views/SAASUsers/ClientManagement.vue"),
                name: 'ClientManagement'
            },
            {
                path: 'add',
                component: () => import("../views/SAASUsers/ClientAddUpdate.vue"),
                name: 'AddClient'
            }
        ]
    },
    {
        path: "/user-management",
        name: "User Management",
        component: EmptyRouterView,
        meta: {
            title: 'User Management'
        },
        children: [
            {
                path: '',
                component: () => import("../views/SAASUsers/UserManagement.vue"),
                name: 'UserManagement'
            },
            {
                path: 'add',
                component: () => import("../views/SAASUsers/UserAddUpdate"),
                name: 'AddUser'
            }
        ]
    },
    {
        path: "/tenant-management",
        name: "Tenant Management",
        component: EmptyRouterView,
        meta: {
            title: 'Tenant Management'
        },
        children: [
            {
                path: '',
                component: () => import("../views/SAASUsers/TenantManagement.vue"),
                name: 'TenantManagement'
            },
            // {
            //     path: 'add',
            //     component: () => import("../views/SAASUsers/UserAddUpdate"),
            //     name: 'AddUser'
            // }
            {
                path: 'view-tenant/:id',
                component: () => import("../views/SAASUsers/TenantDetails"),
                name: 'ViewTenant'
            }
        ]
    },
    {
        path: "/package-config",
        name: "Package Configuration",
        component: EmptyRouterView,
        meta: {
            title: 'Package Configuration'
        },
        children: [
            {
                path: '',
                component: () => import("../views/package-config/PackageConfigList.vue"),
                name: 'Package'
            },
            {
                path: 'add',
                component: () => import("../views/package-config/PackageConfig.vue"),
                name: 'addPackage'
            }
        ]
    },
    {
        path: "/feature-config",
        name: 'Feature Configuration',
        component: EmptyRouterView,
        meta: {
            title: 'Feature configuration'
        },
        children: [
            {
                path:'',
                component: () => import("../views/feature-configuration/FeatureConfigList.vue"),
                name: "Feature"
            },
            {
                path: 'add',
                component: () => import("../views/feature-configuration/AddFeatureConfig.vue"),
                name: 'Add Feature'
            }
        ]
    },
    {
        path: "/zone-management",
        name: 'ZoneManagement',
        component: () => import("../views/zoneManagement/ZoneManagement"),
        meta: {
            title: 'Zone Management'
        },
    },
    {
        path: "/package",
        name: "PackageModule",
        component: () => import("../views/Package/PackageModule.vue"),
        meta: {
            title: 'Package Module'
        }
    },
    {
        path: "/package/add",
        name: "AddUpdateModule",
        component: () => import("@/views/Package/AddUpdateModule.vue"),
        meta: {
            title: 'Add module'
        }
    },
    {
        path: "/package/edit/:modId",
        name: "UpdateModule",
        component: () => import("@/views/Package/UpdateModule.vue"),
        meta: {
            title: 'Edit module'
        }

    },
    {
        path: "/vehicle-type",
        name: "Vehicle Type",
        component: EmptyRouterView,
        meta: {
            title: 'Vehicle Type'
        },
        children: [
            {
                path: '',
                component: () => import("../views/VehicleType/VehicleType.vue"),
                name: 'VehicleType'
            },
            {
                path: 'add',
                component: () => import("../views/VehicleType/VehicleTypeAdd.vue"),
                name: 'AddVehicleType'
            }
        ]
    },
    {
        path: '/callback', // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings
        name: 'oidcCallback',
        component: OidcCallback,
        meta: { layout: "loginlayout", title: 'Login', isPublic: true }
    },
    {
        path: '/logoutSuccess',
        name: 'Logout',
        component: logoutSuccess,
        meta: { layout: "loginlayout", title: 'Logout', isPublic: true }
    },
    {
        path: "*",
        component: NotFoundView,
        meta: { title: 'under construction' }
    }


]


const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    linkActiveClass: "active"
});
router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))

export default router;